<template>
  <v-app>
    <v-navigation-drawer
      clipped
      app
    >
      <v-list
        v-for="(category, i) in categories"
        :key="i"
        dense
      >
        <v-subheader>{{ category.name }}</v-subheader>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, j) in category.items"
            :key="i + '-' + j"
            :to="item.path"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      color="primary"
      clipped-left
      dark
      app
    >
      <v-toolbar-title>
        FrontEnd UI Core Documentation
      </v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-container class="pa-4 pa-sm-6 pa-md-8">
        <v-row justify="center">
          <v-col
            cols="12"
            md="10"
            lg="8"
            xl="6"
          >
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import categories from '@/assets/categories'

export default {
  name: 'App',
  data: () => ({
    categories
  })
}
</script>
